import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex border-t flex-col xl:flex-row pt-4 xl:pt-0" }
const _hoisted_2 = { class: "xl:hidden md:px-8 px-4" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "border-r bg-white hidden overflow-y-auto h-auto xl:block w-[250px] pb-32" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex justify-center mt-4 mb-48" }

import { PlusCircleIcon, LockClosedIcon } from "@heroicons/vue/24/outline";
import { PropType } from "vue";
import { useI18n } from "vue-i18n";
import BasicMenu from "@/components/UI/BasicMenu.vue";
import { useHasProjectFeature } from "@/composables/project";
import { ProcessReport } from "@/types/Process";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
  reports: {
    type: Array as PropType<ProcessReport[]>,
    required: true,
  },
  currentReport: {
    type: Object as PropType<ProcessReport>,
  },
},
  emits: ["handleSwitchReport", "handleCreateReport"],
  setup(__props, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const emits = __emit;

const workingHoursFeatureEnabled = useHasProjectFeature("working_hours");

const handleItemClick = (reportId: string | ProcessReport) => {
  let report = reportId;

  if (typeof reportId === "string") {
    report = props.reports.find((f) => f._id === reportId) as ProcessReport;
  }

  if (report) {
    emits("handleSwitchReport", report);
  }
};

const handleCreateWorkingHourCurveReport = () => {
  if (workingHoursFeatureEnabled) {
    emits("handleCreateReport", "working_hour_curve");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "w-auto oai-inputs",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (handleItemClick(($event?.target as HTMLInputElement)?.value as string)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.reports, (report) => {
          return (_openBlock(), _createElementBlock("option", {
            key: report.name,
            value: report._id,
            selected: __props.currentReport?._id === report._id
          }, _toDisplayString(report.name), 9, _hoisted_3))
        }), 128))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.reports, (report) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([__props.currentReport?._id === report._id && 'bg-yellow-200', "px-5 md:px-8 py-4 lg:p-5 cursor-pointer border-b font-medium text-gray-900 text-sm flex items-center justify-between"]),
          key: report.name,
          onClick: ($event: any) => (handleItemClick(report))
        }, _toDisplayString(report.name), 11, _hoisted_5))
      }), 128)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BasicMenu, { position: "center" }, {
          icon: _withCtx(() => [
            _createVNode(_unref(PlusCircleIcon), { class: "w-10 h-10 text-yellow-300 cursor-pointer hover:text-yellow-500 transition-colors 1" })
          ]),
          content: _withCtx(({ item }) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('handleCreateReport', 'cycle_times')))
            }, {
              default: _withCtx(({ active }) => [
                _createElementVNode("span", {
                  class: _normalizeClass([
                  active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
                  'block px-4 py-2 cursor-pointer',
                ])
                }, _toDisplayString(_unref(t)("analytics.reports.cycle_times_plot")), 3)
              ]),
              _: 2
            }, 1024)),
            (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleCreateWorkingHourCurveReport()))
            }, {
              default: _withCtx(({ active }) => [
                _createElementVNode("span", {
                  class: _normalizeClass([
                  active && _unref(useHasProjectFeature)('working_hours')
                    ? 'bg-gray-100 text-yellow-600 cursor-pointer '
                    : 'text-gray-700',
                  'flex items-center px-4 py-2',
                ])
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)("analytics.reports.working_hour_curve_plot")) + " ", 1),
                  (!_unref(useHasProjectFeature)('working_hours'))
                    ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
                        key: 0,
                        class: "h-4 w-4 ml-2"
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1024))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})